<template lang='pug'>
    div
        OtherPDSensorSelectorLinks
        div.fullwidth(v-if="$route.params.lang == 'en'")

            section.title-container
                h1.product-title AE-150-M
                h2.product-subtitle Acoustic PD Sensor with Protection Case and Magnetic Attachment

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/AE-150-M.webp')
                            img( src='@/assets/photos/product_shots/AE-150-M.png', width="70%", alt='Acoustic PD Sensor AE-150-M', title='Acoustic PD Sensor AE-150-M')
                    .column.factsandbluebox
                        .factbox
                            span.headline Key Features:
                            ul
                                li Ultrasound (acoustic) PD detection
                                li Integrated preamplifier for driving long cables
                                li Excellent EMC properties due to stainless steel housing
                                li Compatible with PDM-600 Ultrasound Channel and PDM-80
                                li Bandwidth: 50 kHz … 400 kHz

                        .bluebox
                            Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet AE-150-M.pdf")
                            Maillink(to='support@bss-hs.de', sub='BS-PD', text='Contact Us', size=30, strokeWidth=2)                            
                            Sitelink(to="/en/products/pdm-600", text='PD Monitoring System PDM-600')
                            Sitelink(to="/en/products/pdm-80", text='PD Monitoring System PDM-80')
                            Sitelink(to="/en/products/pdm-600-mobile", text='PDM-600-Mobile')
                        
            div.margin-bottom
                p Implementing acoustic PD monitoring for transformers has never been easier: The AE-150-M adheres magnetically to ferromagnetic surfaces and enables acoustic PD detection in the typical frequency range. The AE-150-M is compatible with the PDM-600 and PDM-80 PD monitoring systems.

        div.fullwidth(v-if="$route.params.lang == 'de'")

            section.title-container
                h1.product-title AE-150-M
                h2.product-subtitle Akustischer TE-Sensor mit Schutzgehäuse und Magnetbefestigung

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/AE-150-M.webp')
                            img( src='@/assets/photos/product_shots/AE-150-M.png', width="70%", alt='Akustischer TE-Sensor AE-150-M', title='Akustischer TE-Sensor AE-150-M')
                    .column.factsandbluebox
                        .factbox
                            span.headline Highlights:
                            ul
                                li Ultraschall (akustische) TE-Erkennung
                                li Integrierter Vorverstärker für lange Kabel
                                li Hervorragende EMV-Eigenschaften durch Edelstahlgehäuse
                                li Kompatibel mit PDM-600 Ultraschallkanal und PDM-80
                                li Bandbreite: 50 kHz … 400 kHz

                        .bluebox
                            Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet AE-150-M.pdf")
                            Maillink(to='support@bss-hs.de', sub='BS-PD', text='Kontakt', size=30, strokeWidth=2)
                            Sitelink(to="/de/products/pdm-600", text='TE-Monitoringsystem PDM-600')
                            Sitelink(to="/de/products/pdm-80", text='TE-Monitoringsystem PDM-80')
                            Sitelink(to="/de/products/pdm-600-mobile", text='PDM-600-Mobile')
                        
            section.margin-bottom
                p Die Implementierung von akustischem TE-Monitoring für Transformatoren war noch nie so einfach: Der AE-150-M haftet magnetisch an ferromagnetischen Oberflächen und ermöglicht die akustische TE-Erkennung im typischen Frequenzbereich. Der AE-150-M ist mit den TE-Monitoringsystemen PDM-600 und PDM-80 kompatibel.

</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | AE-150-M",
            description:
                "Akustischer TE-Sensor mit Schutzgehäuse und Magnetbefestigung",
        },
        en: {
            title: "BSS | AE-150-M",
            description:
                "Acoustic PD Sensor with Protection Case and Magnetic Attachment",
        },
    },
};
</script>

<style scoped lang='sass'>
</style>